var map = {
	"./audios/exercises/audio_correct.wav": 65806,
	"./audios/exercises/audio_fail.wav": 38460,
	"./audios/exercises/audio_finish.mp3": 4833,
	"./audios/exercises/audio_start.wav": 68908,
	"./audios/game/galactic-warrior/audio_addstar.mp3": 96188,
	"./audios/game/galactic-warrior/audio_answer_correct.mp3": 68842,
	"./audios/game/galactic-warrior/audio_answer_fail.mp3": 30588,
	"./audios/game/galactic-warrior/audio_background.mp3": 29347,
	"./audios/game/galactic-warrior/audio_bonus.mp3": 68996,
	"./audios/game/galactic-warrior/audio_clickmouse.mp3": 65022,
	"./audios/game/galactic-warrior/audio_countdown.mp3": 52832,
	"./audios/game/galactic-warrior/audio_galactic_hover.mp3": 72892,
	"./audios/game/galactic-warrior/audio_stone.mp3": 35230,
	"./fonts/CustomFont/HP001_4_hang_bold.ttf": 82762,
	"./fonts/CustomFont/HP001_5_hang_bold.ttf": 81415,
	"./fonts/CustomFont/HP001_b4h.ttf": 88739,
	"./icons/svg/account/ic_email.svg": 20859,
	"./icons/svg/account/ic_fullname.svg": 3751,
	"./icons/svg/account/ic_password.svg": 34190,
	"./icons/svg/account/ic_phone.svg": 27755,
	"./icons/svg/account/ic_user.svg": 78496,
	"./icons/svg/account/icon_changepassword.svg": 8675,
	"./icons/svg/account/icon_company.svg": 61293,
	"./icons/svg/account/icon_contact.svg": 97108,
	"./icons/svg/account/icon_email.svg": 38608,
	"./icons/svg/account/icon_emails.svg": 85043,
	"./icons/svg/account/icon_error.svg": 1738,
	"./icons/svg/account/icon_file.svg": 17978,
	"./icons/svg/account/icon_gift.svg": 4682,
	"./icons/svg/account/icon_key.svg": 48869,
	"./icons/svg/account/icon_locker.svg": 39732,
	"./icons/svg/account/icon_phone.svg": 26340,
	"./icons/svg/account/icon_phone_big.svg": 92719,
	"./icons/svg/account/icon_place.svg": 23929,
	"./icons/svg/account/icon_refresh.svg": 78833,
	"./icons/svg/account/icon_sisap_code_big.svg": 64471,
	"./icons/svg/account/icon_student.svg": 32905,
	"./icons/svg/account/icon_student_active.svg": 68778,
	"./icons/svg/account/icon_success.svg": 35417,
	"./icons/svg/account/icon_teacher.svg": 16546,
	"./icons/svg/account/icon_teacher_active.svg": 18319,
	"./icons/svg/account/icon_user.svg": 58089,
	"./icons/svg/account/icon_user_big.svg": 96870,
	"./icons/svg/account/icon_user_default.svg": 53931,
	"./icons/svg/account/icon_username.svg": 82000,
	"./icons/svg/account/icon_zalo.svg": 32476,
	"./icons/svg/account/logo_128x128.svg": 33466,
	"./icons/svg/attach/ic_Audio.svg": 37643,
	"./icons/svg/attach/ic_Calendar_24.svg": 12426,
	"./icons/svg/attach/ic_clockOutline.svg": 53591,
	"./icons/svg/attach/ic_doc.svg": 97847,
	"./icons/svg/attach/ic_jpg.svg": 59288,
	"./icons/svg/attach/ic_pdf.svg": 52551,
	"./icons/svg/attach/ic_png.svg": 88708,
	"./icons/svg/attach/ic_pptx.svg": 19275,
	"./icons/svg/attach/ic_video.svg": 59428,
	"./icons/svg/attach/ic_zip.svg": 99660,
	"./icons/svg/attach/icon_pdf.svg": 42864,
	"./icons/svg/attach/icon_video.svg": 69379,
	"./icons/svg/attach/icon_word.svg": 70834,
	"./icons/svg/classroom/ic_BorderCoppyCode.svg": 2801,
	"./icons/svg/classroom/ic_Calendar.svg": 68543,
	"./icons/svg/classroom/ic_Close.svg": 36615,
	"./icons/svg/classroom/ic_ControlPage.svg": 22209,
	"./icons/svg/classroom/ic_EmptyClass.svg": 99308,
	"./icons/svg/classroom/ic_EmptyClassRoom.svg": 16613,
	"./icons/svg/classroom/ic_EmptySearch.svg": 99512,
	"./icons/svg/classroom/ic_EmptyStudent.svg": 40717,
	"./icons/svg/classroom/ic_Messenger_48.svg": 3597,
	"./icons/svg/classroom/ic_Oops.svg": 34068,
	"./icons/svg/classroom/ic_Storage.svg": 66220,
	"./icons/svg/classroom/ic_Success.png": 37236,
	"./icons/svg/classroom/ic_Zalo_48.svg": 20748,
	"./icons/svg/classroom/ic_accept.svg": 76793,
	"./icons/svg/classroom/ic_book_Purple.svg": 56679,
	"./icons/svg/classroom/ic_copy_classcode.png": 80004,
	"./icons/svg/classroom/ic_female.svg": 21941,
	"./icons/svg/classroom/ic_friendly.svg": 79204,
	"./icons/svg/classroom/ic_male.svg": 45998,
	"./icons/svg/classroom/ic_reject.svg": 78084,
	"./icons/svg/classroom/ic_search.svg": 44901,
	"./icons/svg/classroom/ic_share.png": 83696,
	"./icons/svg/classroom/ic_timkiem.svg": 70331,
	"./icons/svg/common/ic_Arrow_Left_24.svg": 64395,
	"./icons/svg/common/ic_BgMessager.svg": 35647,
	"./icons/svg/common/ic_BgRefresh.svg": 96663,
	"./icons/svg/common/ic_Buy.svg": 57849,
	"./icons/svg/common/ic_Chevron_Down_8.svg": 63462,
	"./icons/svg/common/ic_Continue.svg": 1236,
	"./icons/svg/common/ic_EllipseChildrenDone.svg": 91186,
	"./icons/svg/common/ic_EllipseChildrenNoDone.svg": 13123,
	"./icons/svg/common/ic_EllipseDadDone.svg": 51774,
	"./icons/svg/common/ic_EllipseDadNoDone.svg": 86447,
	"./icons/svg/common/ic_MonHoc.svg": 2727,
	"./icons/svg/common/ic_More.svg": 96464,
	"./icons/svg/common/ic_Noti_24.svg": 80460,
	"./icons/svg/common/ic_Pause.svg": 60503,
	"./icons/svg/common/ic_Plus.svg": 83807,
	"./icons/svg/common/ic_abundantCourse.svg": 88911,
	"./icons/svg/common/ic_add.svg": 80260,
	"./icons/svg/common/ic_answer-correct.png": 90210,
	"./icons/svg/common/ic_answer-correct.svg": 98324,
	"./icons/svg/common/ic_answer-fail.png": 23394,
	"./icons/svg/common/ic_answer-fail.svg": 40130,
	"./icons/svg/common/ic_back.svg": 71886,
	"./icons/svg/common/ic_back_purple.svg": 30487,
	"./icons/svg/common/ic_checkbox-done.svg": 22473,
	"./icons/svg/common/ic_checkbox-notdone.svg": 11808,
	"./icons/svg/common/ic_clock.svg": 35975,
	"./icons/svg/common/ic_clock_green.svg": 67003,
	"./icons/svg/common/ic_clock_red.svg": 83735,
	"./icons/svg/common/ic_close.svg": 37041,
	"./icons/svg/common/ic_composeAndAssign.svg": 59087,
	"./icons/svg/common/ic_course-card.svg": 92723,
	"./icons/svg/common/ic_dongho.svg": 93614,
	"./icons/svg/common/ic_down.svg": 54847,
	"./icons/svg/common/ic_edit-exercise.svg": 15802,
	"./icons/svg/common/ic_emoji.svg": 27399,
	"./icons/svg/common/ic_haha.svg": 69271,
	"./icons/svg/common/ic_help.svg": 46918,
	"./icons/svg/common/ic_hoclieu.svg": 16040,
	"./icons/svg/common/ic_hoclieu_active.svg": 28109,
	"./icons/svg/common/ic_home.svg": 250,
	"./icons/svg/common/ic_img.svg": 79060,
	"./icons/svg/common/ic_isSelect.svg": 37895,
	"./icons/svg/common/ic_lesson-free.svg": 24537,
	"./icons/svg/common/ic_like.svg": 34850,
	"./icons/svg/common/ic_love.svg": 85211,
	"./icons/svg/common/ic_more-info.svg": 50049,
	"./icons/svg/common/ic_next_combobox.svg": 82026,
	"./icons/svg/common/ic_next_purple.svg": 69709,
	"./icons/svg/common/ic_previous_combobox.svg": 71626,
	"./icons/svg/common/ic_refresh.svg": 34756,
	"./icons/svg/common/ic_refresh_gray.svg": 69594,
	"./icons/svg/common/ic_search_combo.svg": 90060,
	"./icons/svg/common/ic_sort.svg": 411,
	"./icons/svg/common/ic_sort_type.svg": 49110,
	"./icons/svg/common/ic_support.svg": 95928,
	"./icons/svg/common/ic_teacherCommunity.svg": 58346,
	"./icons/svg/common/ic_up.svg": 5232,
	"./icons/svg/common/ic_wow.svg": 73172,
	"./icons/svg/common/ic_zoom.svg": 31550,
	"./icons/svg/common/icon_account.svg": 17631,
	"./icons/svg/common/icon_attach.svg": 5137,
	"./icons/svg/common/icon_back.svg": 27283,
	"./icons/svg/common/icon_back_old.svg": 64413,
	"./icons/svg/common/icon_cloud.svg": 92701,
	"./icons/svg/common/icon_collapse.svg": 14455,
	"./icons/svg/common/icon_delete.svg": 70959,
	"./icons/svg/common/icon_expand.svg": 18810,
	"./icons/svg/common/icon_folder.svg": 74126,
	"./icons/svg/common/icon_gift.svg": 30944,
	"./icons/svg/common/icon_install_app.svg": 35099,
	"./icons/svg/common/icon_key.svg": 29147,
	"./icons/svg/common/icon_language.svg": 73720,
	"./icons/svg/common/icon_logout.svg": 19364,
	"./icons/svg/common/icon_next_small.svg": 52877,
	"./icons/svg/common/icon_option.svg": 74157,
	"./icons/svg/common/icon_pencil.svg": 95805,
	"./icons/svg/common/icon_plus_violet.svg": 47352,
	"./icons/svg/common/icon_previous_small.svg": 58981,
	"./icons/svg/common/icon_search.svg": 78046,
	"./icons/svg/common/icon_security.svg": 65140,
	"./icons/svg/common/icon_success.svg": 48055,
	"./icons/svg/common/icon_user.svg": 6087,
	"./icons/svg/common/icon_x.svg": 36594,
	"./icons/svg/course-cart/ic_Cart.svg": 47028,
	"./icons/svg/course-cart/ic_Delete.svg": 54155,
	"./icons/svg/dashboard/student/ic_avatar.svg": 90319,
	"./icons/svg/dashboard/student/ic_avatar_non_radius.svg": 81856,
	"./icons/svg/dashboard/student/ic_back_ranking.svg": 25030,
	"./icons/svg/dashboard/student/ic_calendar_bg.svg": 80264,
	"./icons/svg/dashboard/student/ic_calendar_tier1.svg": 25582,
	"./icons/svg/dashboard/student/ic_calendar_tier2.svg": 54701,
	"./icons/svg/dashboard/student/ic_classroom-overview.svg": 3295,
	"./icons/svg/dashboard/student/ic_courses_bg.svg": 12684,
	"./icons/svg/dashboard/student/ic_courses_tier1.svg": 49282,
	"./icons/svg/dashboard/student/ic_courses_tier2.svg": 20177,
	"./icons/svg/dashboard/student/ic_cup.svg": 32760,
	"./icons/svg/dashboard/student/ic_cup_empty.svg": 84714,
	"./icons/svg/dashboard/student/ic_cup_five.svg": 17999,
	"./icons/svg/dashboard/student/ic_cup_four.svg": 93887,
	"./icons/svg/dashboard/student/ic_cup_one.svg": 81789,
	"./icons/svg/dashboard/student/ic_cup_three.svg": 15105,
	"./icons/svg/dashboard/student/ic_cup_two.svg": 44643,
	"./icons/svg/dashboard/student/ic_dashboard_empty_mascot.svg": 64468,
	"./icons/svg/dashboard/student/ic_dashboard_expired.svg": 84054,
	"./icons/svg/dashboard/student/ic_dashboard_mission_mascot.svg": 85035,
	"./icons/svg/dashboard/student/ic_dashboard_next.svg": 21088,
	"./icons/svg/dashboard/student/ic_dashboard_non_submit.svg": 2851,
	"./icons/svg/dashboard/student/ic_dashboard_ranking_mascot.svg": 16531,
	"./icons/svg/dashboard/student/ic_mini_cup_1st_left.svg": 10647,
	"./icons/svg/dashboard/student/ic_mini_cup_1st_right.svg": 27250,
	"./icons/svg/dashboard/student/ic_mini_cup_2nd_left.svg": 49771,
	"./icons/svg/dashboard/student/ic_mini_cup_2nd_right.svg": 44142,
	"./icons/svg/dashboard/student/ic_mini_cup_3rd_left.svg": 50468,
	"./icons/svg/dashboard/student/ic_mini_cup_3rd_right.svg": 1579,
	"./icons/svg/dashboard/student/ic_next_ranking.svg": 19360,
	"./icons/svg/dashboard/student/ic_rank_empty.svg": 95188,
	"./icons/svg/dashboard/student/ic_rate_non_success.svg": 7030,
	"./icons/svg/dashboard/student/ic_student_hard_working.svg": 12527,
	"./icons/svg/dashboard/student/ic_study_evaluate_individual.svg": 73895,
	"./icons/svg/dashboard/student/ic_time_non_submit.svg": 31854,
	"./icons/svg/dashboard/student/study-evaluate-individual/ic_commendation_board.svg": 92601,
	"./icons/svg/dashboard/student/study-evaluate-individual/ic_rate_success.svg": 61820,
	"./icons/svg/dashboard/student/study-evaluate-individual/ic_rate_success_ov.svg": 2460,
	"./icons/svg/dashboard/student/study-evaluate-individual/ic_subject_best.svg": 8531,
	"./icons/svg/dashboard/student/study-evaluate-individual/ic_subject_best_ov.svg": 97185,
	"./icons/svg/dashboard/student/study-evaluate-individual/ic_subject_keeptrying.svg": 74147,
	"./icons/svg/dashboard/student/study-evaluate-individual/ic_subject_keeptrying_ov.svg": 433,
	"./icons/svg/dashboard/student/study-evaluate-individual/ic_submit_exercise.svg": 36799,
	"./icons/svg/dashboard/student/study-evaluate-individual/ic_submit_exercise_ov.svg": 85613,
	"./icons/svg/dashboard/student/study-evaluate-individual/ic_top_hardworking.svg": 43574,
	"./icons/svg/dashboard/student/study-evaluate-individual/ic_top_hardworking_ov.svg": 25646,
	"./icons/svg/dashboard/student/study-evaluate-individual/img_individual_gif.gif": 1368,
	"./icons/svg/dashboard/student/study_hardworking/ic_cup_five.png": 37420,
	"./icons/svg/dashboard/student/study_hardworking/ic_cup_four.png": 43484,
	"./icons/svg/dashboard/student/study_hardworking/ic_cup_one.png": 11158,
	"./icons/svg/dashboard/student/study_hardworking/ic_cup_three.png": 70346,
	"./icons/svg/dashboard/student/study_hardworking/ic_cup_two.png": 79272,
	"./icons/svg/dashboard/teacher/house_ic.svg": 42715,
	"./icons/svg/dashboard/teacher/note_ic.svg": 54531,
	"./icons/svg/dashboard/teacher/paper_plane.svg": 52813,
	"./icons/svg/event_calendar/ic_account_calendar.svg": 79527,
	"./icons/svg/event_calendar/ic_account_organization.svg": 24416,
	"./icons/svg/event_calendar/ic_account_single.svg": 37989,
	"./icons/svg/event_calendar/ic_delete.svg": 9228,
	"./icons/svg/event_calendar/ic_edit.svg": 13825,
	"./icons/svg/event_calendar/ic_gg-drive.svg": 42808,
	"./icons/svg/event_calendar/ic_gg-meet.svg": 10997,
	"./icons/svg/event_calendar/ic_list_calendar.svg": 93482,
	"./icons/svg/event_calendar/ic_manager_calendar.svg": 32627,
	"./icons/svg/event_calendar/ic_mascot_join_meeting.svg": 31053,
	"./icons/svg/event_calendar/ic_meeting_calendar.svg": 83901,
	"./icons/svg/event_calendar/ic_microsoft_avt.svg": 20141,
	"./icons/svg/event_calendar/ic_ms-teams.svg": 9876,
	"./icons/svg/event_calendar/ic_next.svg": 80746,
	"./icons/svg/event_calendar/ic_zoom.svg": 49712,
	"./icons/svg/examination/correct/ic_instruct.svg": 24782,
	"./icons/svg/examination/ic_Bronze_156.svg": 95094,
	"./icons/svg/examination/ic_Gold_156.svg": 27292,
	"./icons/svg/examination/ic_Note.svg": 13283,
	"./icons/svg/examination/ic_Silver_156.svg": 25193,
	"./icons/svg/examination/ic_correct_answer.svg": 98560,
	"./icons/svg/examination/ic_end_time.svg": 77214,
	"./icons/svg/examination/ic_exam_correct.svg": 98381,
	"./icons/svg/examination/ic_exam_not_done.svg": 32279,
	"./icons/svg/examination/ic_exam_wrong.svg": 47948,
	"./icons/svg/examination/ic_incorrect_answer.svg": 36373,
	"./icons/svg/examination/ic_last_edited.svg": 13121,
	"./icons/svg/examination/ic_lock.svg": 52186,
	"./icons/svg/examination/ic_max_point.svg": 4784,
	"./icons/svg/examination/ic_notdone_answer.svg": 2159,
	"./icons/svg/examination/ic_qty_question.svg": 66492,
	"./icons/svg/examination/ic_start_time.svg": 1071,
	"./icons/svg/examination/ic_student.svg": 82212,
	"./icons/svg/examination/ic_teacher.svg": 24187,
	"./icons/svg/examination/ic_time.svg": 78056,
	"./icons/svg/examination/ic_time_period.svg": 60660,
	"./icons/svg/exercise/community/rating-detail/ic_Check_green.svg": 62894,
	"./icons/svg/exercise/community/rating-detail/ic_Next_blue.svg": 36088,
	"./icons/svg/exercise/community/rating-detail/ic_Next_green.svg": 87917,
	"./icons/svg/exercise/community/rating-detail/ic_Next_purple.svg": 51314,
	"./icons/svg/exercise/community/rating-detail/ic_Next_red.svg": 32257,
	"./icons/svg/exercise/community/rating-detail/ic_Next_silver.svg": 71799,
	"./icons/svg/exercise/community/rating-detail/ic_Next_yellow.svg": 30196,
	"./icons/svg/exercise/compose/back_question.svg": 96000,
	"./icons/svg/exercise/compose/bg_all_result.svg": 23267,
	"./icons/svg/exercise/compose/bg_fail_result.svg": 47540,
	"./icons/svg/exercise/compose/bg_success_result.svg": 28691,
	"./icons/svg/exercise/compose/ck_link.svg": 6637,
	"./icons/svg/exercise/compose/ck_media.svg": 94711,
	"./icons/svg/exercise/compose/ck_redo.svg": 9837,
	"./icons/svg/exercise/compose/ck_undo.svg": 84143,
	"./icons/svg/exercise/compose/editor-tool/ck_align-center.svg": 17485,
	"./icons/svg/exercise/compose/editor-tool/ck_align-even.svg": 26962,
	"./icons/svg/exercise/compose/editor-tool/ck_align-left.svg": 29973,
	"./icons/svg/exercise/compose/editor-tool/ck_align-right.svg": 19896,
	"./icons/svg/exercise/compose/editor-tool/ck_align.svg": 25025,
	"./icons/svg/exercise/compose/editor-tool/ck_bold.svg": 18479,
	"./icons/svg/exercise/compose/editor-tool/ck_file.svg": 99188,
	"./icons/svg/exercise/compose/editor-tool/ck_italic.svg": 10978,
	"./icons/svg/exercise/compose/editor-tool/ck_link.svg": 62054,
	"./icons/svg/exercise/compose/editor-tool/ck_mathtype.svg": 49568,
	"./icons/svg/exercise/compose/editor-tool/ck_media.svg": 1134,
	"./icons/svg/exercise/compose/editor-tool/ck_redo.svg": 84358,
	"./icons/svg/exercise/compose/editor-tool/ck_strike.svg": 56888,
	"./icons/svg/exercise/compose/editor-tool/ck_table.svg": 31330,
	"./icons/svg/exercise/compose/editor-tool/ck_underline.svg": 36370,
	"./icons/svg/exercise/compose/editor-tool/ck_undo.svg": 10400,
	"./icons/svg/exercise/compose/ic_AnswerMore.svg": 8982,
	"./icons/svg/exercise/compose/ic_Back.svg": 56046,
	"./icons/svg/exercise/compose/ic_Next.svg": 41976,
	"./icons/svg/exercise/compose/ic_RadioButton_InActive_16 (Active).svg": 80033,
	"./icons/svg/exercise/compose/ic_RadioButton_InActive_16 (Disable Active).svg": 74277,
	"./icons/svg/exercise/compose/ic_RadioButton_InActive_16 (Disable Inactive).svg": 13734,
	"./icons/svg/exercise/compose/ic_RadioButton_InActive_16 (Hover).svg": 59865,
	"./icons/svg/exercise/compose/ic_RadioButton_InActive_16 (Inactive).svg": 46250,
	"./icons/svg/exercise/compose/ic_RadioButton_InActive_16.svg": 47890,
	"./icons/svg/exercise/compose/ic_ToastMessage_Info.svg": 11812,
	"./icons/svg/exercise/compose/ic_arrow.svg": 34802,
	"./icons/svg/exercise/compose/ic_check.svg": 93285,
	"./icons/svg/exercise/compose/ic_close-tag.svg": 25086,
	"./icons/svg/exercise/compose/ic_close.svg": 56433,
	"./icons/svg/exercise/compose/ic_compose_option.svg": 89719,
	"./icons/svg/exercise/compose/ic_dublicate.svg": 64836,
	"./icons/svg/exercise/compose/ic_error.svg": 27291,
	"./icons/svg/exercise/compose/ic_esay.png": 77067,
	"./icons/svg/exercise/compose/ic_extract.svg": 19722,
	"./icons/svg/exercise/compose/ic_eye.svg": 582,
	"./icons/svg/exercise/compose/ic_fill.png": 52094,
	"./icons/svg/exercise/compose/ic_info.svg": 1199,
	"./icons/svg/exercise/compose/ic_more.svg": 56432,
	"./icons/svg/exercise/compose/ic_more_v2.svg": 50035,
	"./icons/svg/exercise/compose/ic_pairing.png": 36529,
	"./icons/svg/exercise/compose/ic_plus.svg": 23615,
	"./icons/svg/exercise/compose/ic_remove.png": 18777,
	"./icons/svg/exercise/compose/ic_remove.svg": 87527,
	"./icons/svg/exercise/compose/ic_select.png": 51093,
	"./icons/svg/exercise/compose/ic_uncheck.svg": 22390,
	"./icons/svg/exercise/compose/ic_upload-image.svg": 45480,
	"./icons/svg/exercise/compose/ic_yesorno.png": 52314,
	"./icons/svg/exercise/compose/icon_answer_active.svg": 87721,
	"./icons/svg/exercise/compose/icon_answer_compose.svg": 37773,
	"./icons/svg/exercise/compose/icon_answer_inactive.svg": 51004,
	"./icons/svg/exercise/compose/icon_answer_upload.svg": 91920,
	"./icons/svg/exercise/compose/icon_check.svg": 1302,
	"./icons/svg/exercise/compose/icon_check_false.svg": 92506,
	"./icons/svg/exercise/compose/icon_check_true.svg": 82865,
	"./icons/svg/exercise/compose/icon_compose_answer_big.svg": 15788,
	"./icons/svg/exercise/compose/icon_extract_fail.svg": 86820,
	"./icons/svg/exercise/compose/icon_extract_to_image.svg": 32949,
	"./icons/svg/exercise/compose/icon_extract_to_paragraph.svg": 70912,
	"./icons/svg/exercise/compose/icon_extracting.svg": 62227,
	"./icons/svg/exercise/compose/icon_hint_active.svg": 44126,
	"./icons/svg/exercise/compose/icon_hint_inactive.svg": 89491,
	"./icons/svg/exercise/compose/icon_info.svg": 8430,
	"./icons/svg/exercise/compose/icon_star.svg": 81486,
	"./icons/svg/exercise/compose/next_question.svg": 53886,
	"./icons/svg/exercise/compose/questions/bg_button_yellow.svg": 90609,
	"./icons/svg/exercise/compose/questions/ic_add-answer.svg": 20253,
	"./icons/svg/exercise/compose/questions/ic_more.svg": 92230,
	"./icons/svg/exercise/compose/questions/icon_back.svg": 91965,
	"./icons/svg/exercise/compose/remove-document-3872_dac3ac54-5c49-4995-9eeb-65d8dabb6bd8.svg": 58351,
	"./icons/svg/exercise/compose/tag_arrow_down.svg": 44445,
	"./icons/svg/exercise/compose/tag_arrow_up.svg": 92834,
	"./icons/svg/exercise/correct/ic_User_16.svg": 78350,
	"./icons/svg/exercise/correct/ic_User_16T.svg": 74926,
	"./icons/svg/exercise/correct/ic_chambai.svg": 75438,
	"./icons/svg/exercise/correct/ic_dacham.svg": 49251,
	"./icons/svg/exercise/correct/ic_dangcham.svg": 802,
	"./icons/svg/exercise/correct/ic_instruct.svg": 51239,
	"./icons/svg/exercise/correct/ic_number_aswer.svg": 87973,
	"./icons/svg/exercise/correct/ic_number_aswer_white.svg": 24143,
	"./icons/svg/exercise/correct/ic_oclock.svg": 49690,
	"./icons/svg/exercise/correct/ic_xembai.svg": 1787,
	"./icons/svg/exercise/file-upload/ic_add_file.svg": 85921,
	"./icons/svg/exercise/file-upload/ic_answer.svg": 6353,
	"./icons/svg/exercise/file-upload/ic_answer_active.svg": 68898,
	"./icons/svg/exercise/file-upload/ic_answer_file.svg": 61870,
	"./icons/svg/exercise/file-upload/ic_answer_file_active.svg": 28003,
	"./icons/svg/exercise/file-upload/ic_copy.svg": 9768,
	"./icons/svg/exercise/file-upload/ic_line.svg": 77241,
	"./icons/svg/exercise/file-upload/ic_line_active.svg": 9274,
	"./icons/svg/exercise/file-upload/ic_listanswer.svg": 37477,
	"./icons/svg/exercise/file-upload/ic_note.svg": 22803,
	"./icons/svg/exercise/file-upload/ic_note_active.svg": 6548,
	"./icons/svg/exercise/file-upload/ic_note_active_old.svg": 55854,
	"./icons/svg/exercise/file-upload/ic_note_old.svg": 12797,
	"./icons/svg/exercise/file-upload/ic_progress_hide.svg": 65805,
	"./icons/svg/exercise/file-upload/ic_progress_show.svg": 91614,
	"./icons/svg/exercise/file-upload/icon_file_white.svg": 8010,
	"./icons/svg/exercise/file-upload/icon_upload_file.svg": 81734,
	"./icons/svg/exercise/ic_Arrow_Right.svg": 37502,
	"./icons/svg/exercise/ic_Download.svg": 97886,
	"./icons/svg/exercise/ic_Print.svg": 76767,
	"./icons/svg/exercise/patner/ic_BgDocument.svg": 81185,
	"./icons/svg/exercise/patner/ic_BgFree.svg": 59452,
	"./icons/svg/exercise/patner/ic_BgMinus.svg": 44886,
	"./icons/svg/exercise/patner/ic_BgPlus.svg": 18718,
	"./icons/svg/exercise/patner/ic_BgTime.svg": 17957,
	"./icons/svg/ic_ArrowLeft.svg": 53183,
	"./icons/svg/ic_ArrowRight.svg": 94554,
	"./icons/svg/ic_ArrowRightSmall.svg": 5591,
	"./icons/svg/ic_Arrow_Left_24.svg": 1245,
	"./icons/svg/ic_Back_48.png": 10225,
	"./icons/svg/ic_Back_48.svg": 17731,
	"./icons/svg/ic_Back_48@2x.png": 82035,
	"./icons/svg/ic_Back_48_BG_Black.svg": 81843,
	"./icons/svg/ic_Book_128.svg": 19336,
	"./icons/svg/ic_Book_60.svg": 52275,
	"./icons/svg/ic_Chevron_Left_8.svg": 62995,
	"./icons/svg/ic_Chevron_Right_8.svg": 4124,
	"./icons/svg/ic_ChuaNop.svg": 89669,
	"./icons/svg/ic_ClassroomOnline.svg": 83911,
	"./icons/svg/ic_DaHetHan.svg": 38112,
	"./icons/svg/ic_DaLam.svg": 91722,
	"./icons/svg/ic_DaNop.svg": 1231,
	"./icons/svg/ic_DisLike.svg": 71702,
	"./icons/svg/ic_Done.svg": 45329,
	"./icons/svg/ic_Done_Full_Back_Ground.svg": 43663,
	"./icons/svg/ic_Down.svg": 63985,
	"./icons/svg/ic_Empty.svg": 24980,
	"./icons/svg/ic_ExerciseDone.svg": 91623,
	"./icons/svg/ic_Filter.svg": 66171,
	"./icons/svg/ic_Flag.svg": 98163,
	"./icons/svg/ic_GhiChu_64.svg": 83158,
	"./icons/svg/ic_Help.svg": 14068,
	"./icons/svg/ic_IsCheck.svg": 68999,
	"./icons/svg/ic_JoinClassSuccess.svg": 56668,
	"./icons/svg/ic_LamBai_60.svg": 23396,
	"./icons/svg/ic_Like.svg": 66260,
	"./icons/svg/ic_Logo.svg": 66424,
	"./icons/svg/ic_MortarBoard.svg": 41542,
	"./icons/svg/ic_Next.svg": 35842,
	"./icons/svg/ic_Next_48.svg": 51981,
	"./icons/svg/ic_Next_48_BG_Black.svg": 72357,
	"./icons/svg/ic_Not_Done.svg": 283,
	"./icons/svg/ic_PDF_24.svg": 71618,
	"./icons/svg/ic_PowerPoint_24.svg": 78319,
	"./icons/svg/ic_Prev.svg": 4926,
	"./icons/svg/ic_Taivemay.svg": 88433,
	"./icons/svg/ic_Truck.svg": 75598,
	"./icons/svg/ic_Video_24.svg": 34419,
	"./icons/svg/ic_WaitApprove.svg": 93877,
	"./icons/svg/ic_Word_24.svg": 98006,
	"./icons/svg/ic_XemChiTiet_60.svg": 58652,
	"./icons/svg/ic_XemKetQua_60.svg": 61935,
	"./icons/svg/ic_addImage.svg": 8421,
	"./icons/svg/ic_back_blue.svg": 559,
	"./icons/svg/ic_check.svg": 20323,
	"./icons/svg/ic_close.svg": 52631,
	"./icons/svg/ic_correct.svg": 34993,
	"./icons/svg/ic_course_image.png": 62380,
	"./icons/svg/ic_createRegistrationForm.svg": 89724,
	"./icons/svg/ic_detailAnswer.svg": 38304,
	"./icons/svg/ic_false.svg": 77858,
	"./icons/svg/ic_fix-anwser.svg": 16957,
	"./icons/svg/ic_pdf.svg": 79885,
	"./icons/svg/ic_pencil.svg": 34506,
	"./icons/svg/ic_pencil_accent.svg": 5075,
	"./icons/svg/ic_plus.svg": 3769,
	"./icons/svg/ic_png.svg": 80302,
	"./icons/svg/ic_pp.svg": 16685,
	"./icons/svg/ic_received.svg": 72136,
	"./icons/svg/ic_registerSuccess.svg": 68119,
	"./icons/svg/ic_removeAnswer.svg": 3959,
	"./icons/svg/ic_speaker.svg": 21724,
	"./icons/svg/ic_timkiem.svg": 47051,
	"./icons/svg/ic_txt.svg": 31983,
	"./icons/svg/ic_v.svg": 89889,
	"./icons/svg/icon_copy.svg": 92011,
	"./icons/svg/icon_delete_excercise.svg": 5083,
	"./icons/svg/icon_edit_excercise.svg": 25306,
	"./icons/svg/icon_favourite_exercise.svg": 67446,
	"./icons/svg/il_Search_128.svg": 6506,
	"./icons/svg/lesson_note/option.svg": 20315,
	"./icons/svg/lesson_note/send.svg": 88706,
	"./icons/svg/logo/logo_login.svg": 64961,
	"./icons/svg/navbar/ic_KiemTra_24.svg": 46164,
	"./icons/svg/navbar/ic_More_24.svg": 56170,
	"./icons/svg/navbar/ic_OnLuyen_24.svg": 15521,
	"./icons/svg/navbar/ic_baitap.svg": 27697,
	"./icons/svg/navbar/ic_calendar.svg": 87528,
	"./icons/svg/navbar/ic_chart.svg": 4566,
	"./icons/svg/navbar/ic_class_room.svg": 1660,
	"./icons/svg/navbar/ic_dashboard.svg": 50738,
	"./icons/svg/navbar/ic_document.svg": 65625,
	"./icons/svg/navbar/ic_exercise.svg": 44292,
	"./icons/svg/navbar/ic_home.svg": 55139,
	"./icons/svg/navbar/ic_hsinh.svg": 69856,
	"./icons/svg/navbar/ic_info.svg": 36626,
	"./icons/svg/navbar/ic_lichhoc.svg": 72764,
	"./icons/svg/navbar/ic_multi.svg": 8221,
	"./icons/svg/navbar/ic_news_feed.svg": 9078,
	"./icons/svg/navbar/ic_practice.svg": 9201,
	"./icons/svg/navbar/ic_profile.svg": 81257,
	"./icons/svg/navbar/ic_student.svg": 16823,
	"./icons/svg/navbar/ic_teacher.svg": 52072,
	"./icons/svg/navbar/ic_tintuc.svg": 20781,
	"./icons/svg/navbar/seft_learning.svg": 58598,
	"./icons/svg/practice/ic_book_green.svg": 8048,
	"./icons/svg/practice/ic_hoclieu_purple.svg": 57561,
	"./icons/svg/practice/ic_home_orange.svg": 81831,
	"./icons/svg/practice/ic_sending_hocmai.svg": 4935,
	"./icons/svg/ranking/background_rank.svg": 70808,
	"./icons/svg/ranking/ic_Rank.svg": 53600,
	"./icons/svg/ranking/icon_one.svg": 28237,
	"./icons/svg/ranking/icon_three.svg": 31857,
	"./icons/svg/ranking/icon_two.svg": 98611,
	"./icons/svg/ranking/rank_1.svg": 56049,
	"./icons/svg/ranking/rank_2.svg": 35682,
	"./icons/svg/ranking/rank_3.svg": 57203,
	"./icons/svg/register/ic_Gif.svg": 34707,
	"./icons/svg/register/ic_Logo.svg": 48798,
	"./icons/svg/self-learning/ic_Exam.svg": 51100,
	"./icons/svg/self-learning/ic_QuestionNumber.svg": 24982,
	"./icons/svg/self-learning/ic_book.svg": 38134,
	"./icons/svg/self-learning/ic_checkFail.svg": 3955,
	"./icons/svg/self-learning/ic_checkSuccess.svg": 30452,
	"./icons/svg/self-learning/ic_did.svg": 38580,
	"./icons/svg/self-learning/ic_did_active.svg": 84385,
	"./icons/svg/self-learning/ic_document.svg": 29126,
	"./icons/svg/self-learning/ic_donot.svg": 65285,
	"./icons/svg/self-learning/ic_donot_active.svg": 75150,
	"./icons/svg/self-learning/ic_exambank.svg": 65086,
	"./icons/svg/self-learning/ic_false.svg": 94010,
	"./icons/svg/self-learning/ic_flag.svg": 77819,
	"./icons/svg/self-learning/ic_free.svg": 75735,
	"./icons/svg/self-learning/ic_help.svg": 58508,
	"./icons/svg/self-learning/ic_nextQuestion.svg": 74714,
	"./icons/svg/self-learning/ic_overview.svg": 18840,
	"./icons/svg/self-learning/ic_practice.svg": 53074,
	"./icons/svg/self-learning/ic_practicetopics.svg": 81458,
	"./icons/svg/self-learning/ic_pro.svg": 86162,
	"./icons/svg/self-learning/ic_questionbank.svg": 77163,
	"./icons/svg/self-learning/ic_skip.svg": 9476,
	"./icons/svg/self-learning/ic_sub.svg": 92433,
	"./icons/svg/self-learning/ic_success.svg": 38078,
	"./icons/svg/self-learning/ic_support.svg": 35862,
	"./icons/svg/self-learning/ic_theformed.svg": 3063,
	"./icons/svg/self-learning/ic_time.svg": 85258,
	"./icons/svg/self-learning/mascot_fail.svg": 53578,
	"./icons/svg/self-learning/mascot_success.svg": 35523,
	"./icons/svg/storage-exercise/icon_package.svg": 97937,
	"./icons/svg/subsystem/ic_exam.svg": 30596,
	"./icons/svg/subsystem/ic_homework.svg": 2067,
	"./icons/svg/subsystem/ic_manage_student.svg": 34064,
	"./icons/svg/subsystem/ic_room.svg": 39856,
	"./icons/svg/user_info/changing.svg": 27140,
	"./icons/svg/user_info/diamond_bg.png": 54837,
	"./icons/svg/user_info/diamond_frame.svg": 20077,
	"./icons/svg/user_info/frame.svg": 93484,
	"./icons/svg/user_info/gold_bg.png": 35055,
	"./icons/svg/user_info/gold_frame.svg": 4557,
	"./icons/svg/user_info/ic_Back_48.svg": 44532,
	"./icons/svg/user_info/ic_Calendar_16.svg": 99756,
	"./icons/svg/user_info/ic_Cup_1st_80.svg": 19172,
	"./icons/svg/user_info/ic_Cup_2nd_80.svg": 17752,
	"./icons/svg/user_info/ic_Cup_3rd_80.svg": 39843,
	"./icons/svg/user_info/ic_Diary_20.svg": 99710,
	"./icons/svg/user_info/ic_Help_20.svg": 94638,
	"./icons/svg/user_info/ic_Info_20.svg": 29557,
	"./icons/svg/user_info/ic_LogOut_20.svg": 20583,
	"./icons/svg/user_info/ic_Material.svg": 55631,
	"./icons/svg/user_info/ic_Next_48.svg": 51502,
	"./icons/svg/user_info/ic_Password_20.svg": 51284,
	"./icons/svg/user_info/ic_Photo_36.svg": 36212,
	"./icons/svg/user_info/ic_Registration.svg": 14551,
	"./icons/svg/user_info/ic_Repair.svg": 8627,
	"./icons/svg/user_info/ic_School_20.svg": 86757,
	"./icons/svg/user_info/ic_Setting_24.svg": 92385,
	"./icons/svg/user_info/ic_Sync_20.svg": 71758,
	"./icons/svg/user_info/ic_User_20.svg": 70318,
	"./icons/svg/user_info/ic_classroom.svg": 3149,
	"./icons/svg/user_info/icon_info.svg": 82317,
	"./icons/svg/user_info/icon_logout.svg": 45143,
	"./icons/svg/user_info/icon_password.svg": 81206,
	"./icons/svg/user_info/icon_security.svg": 74967,
	"./icons/svg/user_info/photo-camera.svg": 29041,
	"./icons/svg/user_info/silver_bg.png": 94844,
	"./icons/svg/user_info/silver_frame.svg": 3336,
	"./icons/svg/user_info/special_bg.png": 73342,
	"./icons/svg/user_info/special_frame.svg": 69440,
	"./icons/svg/user_info/star.svg": 58441,
	"./images/jpg/avatar_Son.jpg": 91785,
	"./images/jpg/backgrounds/background_login.jpg": 451,
	"./images/jpg/backgrounds/background_test.jpg": 26338,
	"./images/jpg/backgrounds/banner_default.jpg": 91861,
	"./images/jpg/dashboard/bg_dashboard_1.jpg": 47068,
	"./images/jpg/dashboard/bg_dashboard_2.jpg": 39051,
	"./images/jpg/dashboard/bg_dashboard_3.jpg": 61006,
	"./images/jpg/exercise-theme/background/Background_1366_Basic.jpg": 2175,
	"./images/jpg/exercise-theme/background/Background_1366_Jungle.jpg": 91478,
	"./images/jpg/exercise-theme/background/Background_1366_Sea.jpg": 37160,
	"./images/jpg/exercise-theme/background/Background_1366_Space.jpg": 65803,
	"./images/jpg/exercise-theme/background/Background_1920_Basic.jpg": 38463,
	"./images/jpg/exercise-theme/background/Background_1920_Jungle.jpg": 27606,
	"./images/jpg/exercise-theme/background/Background_1920_Sea.jpg": 37000,
	"./images/jpg/exercise-theme/background/Background_1920_Space.jpg": 17099,
	"./images/jpg/exercise/ground/bg_ground_1.jpg": 71747,
	"./images/jpg/exercise/ground/bg_ground_2.jpg": 93620,
	"./images/jpg/exercise/ground/bg_ground_3.jpg": 90993,
	"./images/jpg/exercise/ground/bg_ground_4.jpg": 1762,
	"./images/jpg/exercise/ground/bg_ground_5.jpg": 14431,
	"./images/jpg/exercise/ground/bg_ground_6.jpg": 30096,
	"./images/jpg/exercise/ocean/bg_ocean_1.jpg": 40425,
	"./images/jpg/exercise/sky/bg_sky_1.jpg": 235,
	"./images/jpg/exercise/sky/bg_sky_2.jpg": 8252,
	"./images/jpg/exercise/sky/bg_sky_3.jpg": 12953,
	"./images/jpg/hocmai/TH/hoc-gioi_lop1_TV.jpg": 97113,
	"./images/jpg/hocmai/TH/hoc-gioi_lop1_Toan.jpg": 82237,
	"./images/jpg/hocmai/TH/hoc-gioi_lop2_TV.jpg": 61472,
	"./images/jpg/hocmai/TH/hoc-gioi_lop2_Toan.jpg": 69424,
	"./images/jpg/hocmai/TH/hoc-gioi_lop3_TA.jpg": 65288,
	"./images/jpg/hocmai/TH/hoc-gioi_lop3_TV.jpg": 39659,
	"./images/jpg/hocmai/TH/hoc-gioi_lop3_Toan.jpg": 66211,
	"./images/jpg/hocmai/TH/hoc-gioi_lop4_TA.jpg": 74201,
	"./images/jpg/hocmai/TH/hoc-gioi_lop4_TV.jpg": 10522,
	"./images/jpg/hocmai/TH/hoc-gioi_lop4_Toan.jpg": 10110,
	"./images/jpg/hocmai/TH/hoc-gioi_lop5_TA.jpg": 70694,
	"./images/jpg/hocmai/TH/hoc-gioi_lop5_TV.jpg": 74525,
	"./images/jpg/hocmai/TH/hoc-gioi_lop5_Toan.jpg": 1801,
	"./images/jpg/hocmai/THCS/Hoc-tot-7_van-1.jpg": 36184,
	"./images/jpg/hocmai/THCS/Hoc-tot-7_vat-li.jpg": 2962,
	"./images/jpg/hocmai/THCS/Hoc-tot-8_anh-10_1.jpg": 98883,
	"./images/jpg/hocmai/THCS/Hoc-tot-8_hoa-2.jpg": 18611,
	"./images/jpg/hocmai/THCS/Hoc-tot-8_sinh.jpg": 41562,
	"./images/jpg/hocmai/THCS/Hoc-tot-8_toan-2.jpg": 14771,
	"./images/jpg/hocmai/THCS/Hoc-tot-8_van-HCM.jpg": 43006,
	"./images/jpg/hocmai/THCS/Hoc-tot-8_vat-li-2.jpg": 42734,
	"./images/jpg/hocmai/THCS/Hoc-tot-9_GDCD.jpg": 40979,
	"./images/jpg/hocmai/THCS/Hoc-tot-9_anh-10.2.jpg": 75124,
	"./images/jpg/hocmai/THCS/Hoc-tot-9_dia-li.jpg": 55357,
	"./images/jpg/hocmai/THCS/Hoc-tot-9_hoa-2.jpg": 61618,
	"./images/jpg/hocmai/THCS/Hoc-tot-9_sinh.jpg": 35661,
	"./images/jpg/hocmai/THCS/Hoc-tot-9_toan 1.jpg": 96324,
	"./images/jpg/hocmai/THCS/Hoc-tot-9_van.jpg": 69700,
	"./images/jpg/hocmai/THCS/Hoc-tot-9_vat-li.jpg": 73340,
	"./images/jpg/hocmai/THCS/hoc-tot-7_anh-10_2.jpg": 19245,
	"./images/jpg/hocmai/THCS/hoc-tot-7_toan.jpg": 69635,
	"./images/jpg/hocmai/THPT/Hoc-tot-10_Ly-2.jpg": 63995,
	"./images/jpg/hocmai/THPT/Hoc-tot-10_Sinh.jpg": 85853,
	"./images/jpg/hocmai/THPT/Hoc-tot-10_Toan-1.jpg": 43195,
	"./images/jpg/hocmai/THPT/Hoc-tot-10_Van.jpg": 23668,
	"./images/jpg/hocmai/THPT/Hoc-tot-12_anh.jpg": 17906,
	"./images/jpg/hocmai/THPT/Hoc-tot-12_hoa.jpg": 11425,
	"./images/jpg/hocmai/THPT/Hoc-tot-12_li_dnh.jpg": 29695,
	"./images/jpg/hocmai/THPT/Hoc-tot-12_sinh.jpg": 79763,
	"./images/jpg/hocmai/THPT/Hoc-tot-12_toan_lht.jpg": 2414,
	"./images/jpg/hocmai/THPT/Hoc-tot-12_van_đnk.jpg": 63659,
	"./images/jpg/hocmai/THPT/hoc-tot-anh-10-10_1.jpg": 33454,
	"./images/jpg/hocmai/THPT/hoc-tot-anh-11-10_1.jpg": 86093,
	"./images/jpg/teach-exam-period/ic_dongho.jpg": 86721,
	"./images/mascot/self-learning/mascot_check_after-submit.svg": 92823,
	"./images/mascot/self-learning/mascot_check_every-sentence.svg": 29549,
	"./images/png/account/img_QR.png": 54898,
	"./images/png/category/Backgroud_40.png": 8825,
	"./images/png/category/Backgroud_Creative.png": 83786,
	"./images/png/category/Backgroud_New.png": 97919,
	"./images/png/category/Backgroud_Positive.png": 20584,
	"./images/png/category/Backgroud_Technology.png": 91227,
	"./images/png/category/Background_Image.png": 66130,
	"./images/png/category/Background_NPS.png": 75904,
	"./images/png/category/Background_Opacity.png": 26798,
	"./images/png/category/Layer_Category_1.png": 20882,
	"./images/png/category/Layer_Category_2.png": 11593,
	"./images/png/category/Layer_Category_3.png": 56768,
	"./images/png/category/Layer_Category_4.png": 8095,
	"./images/png/category/Layer_Category_5.png": 11766,
	"./images/png/category/Mask_Group.png": 68948,
	"./images/png/category/Subtraction_1.png": 5632,
	"./images/png/category/Subtraction_3.png": 69138,
	"./images/png/category/Subtraction_Arrow.png": 75374,
	"./images/png/category/Subtraction_Big.png": 49095,
	"./images/png/category/Subtraction_Small.png": 45808,
	"./images/png/category/avarta_son.jpg": 98444,
	"./images/png/category/bn_ranking_exercise.png": 83142,
	"./images/png/category/ic_Favorite_Off.png": 21831,
	"./images/png/category/ic_Favorite_On.png": 71773,
	"./images/png/exercise/background/bg_01.png": 44722,
	"./images/png/exercise/background/bg_02.png": 35433,
	"./images/png/exercise/background/bg_03.png": 80608,
	"./images/png/exercise/background/bg_04.png": 15583,
	"./images/png/exercise/background/bg_05.png": 35606,
	"./images/png/exercise/background/bg_06.png": 17229,
	"./images/png/exercise/background/bg_07.png": 60932,
	"./images/png/exercise/background/bg_08.png": 34947,
	"./images/png/exercise/background/bg_09.png": 17370,
	"./images/png/exercise/background/bg_10.png": 9328,
	"./images/png/exercise/background/bg_11.png": 6233,
	"./images/png/exercise/compose/compose_mutilchoice_1.png": 58992,
	"./images/png/exercise/compose/compose_mutilchoice_2.png": 89163,
	"./images/png/exercise/compose/essay-exercise_1.png": 4869,
	"./images/png/exercise/compose/essay-exercise_2.png": 86094,
	"./images/png/exercise/compose/extract-exercise_1.png": 19075,
	"./images/png/exercise/compose/extract-exercise_2.png": 82216,
	"./images/png/exercise/compose/extract-exercise_3.png": 76081,
	"./images/png/practice/success_support.png": 53100,
	"./images/png/practice/synthetic_large.png": 76496,
	"./images/png/practice/synthetic_medium.png": 23796,
	"./images/png/practice/synthetic_short.png": 36459,
	"./images/png/storage/bgc_registrationSuccess.png": 82484,
	"./images/png/storage/ic_HeartBlue.png": 88304,
	"./images/png/storage/ic_HeartDefault.png": 77149,
	"./images/png/storage/ic_HeartWhite.png": 54821,
	"./images/png/storage/img_refer.png": 8203,
	"./images/png/subject/nguvan_temp.png": 22168,
	"./images/png/subject/tiengviet_temp.png": 70192,
	"./images/png/theme/ic_XemChiTiet_60.svg": 13119,
	"./images/png/touch-point/limit/limit-favourit_exercise.png": 51481,
	"./images/png/training/bg_recommend.png": 61208,
	"./images/png/training/bg_training.png": 49986,
	"./images/svg/avatar/avatar_1.svg": 59963,
	"./images/svg/avatar/avatar_10.svg": 41633,
	"./images/svg/avatar/avatar_11.svg": 50512,
	"./images/svg/avatar/avatar_12.svg": 39907,
	"./images/svg/avatar/avatar_13.svg": 14213,
	"./images/svg/avatar/avatar_2.svg": 9224,
	"./images/svg/avatar/avatar_3.svg": 74617,
	"./images/svg/avatar/avatar_4.svg": 34582,
	"./images/svg/avatar/avatar_5.svg": 98407,
	"./images/svg/avatar/avatar_6.svg": 33844,
	"./images/svg/avatar/avatar_7.svg": 6453,
	"./images/svg/avatar/avatar_8.svg": 52338,
	"./images/svg/avatar/avatar_9.svg": 66979,
	"./images/svg/button/ic_BT Delete_40.svg": 26590,
	"./images/svg/button/ic_BT Edit_40.svg": 93610,
	"./images/svg/category/Background_Opacity.svg": 52447,
	"./images/svg/common/ic_Calendar_16.svg": 31973,
	"./images/svg/common/ic_success.svg": 94248,
	"./images/svg/common/icon_book.svg": 19637,
	"./images/svg/common/icon_oops.svg": 44347,
	"./images/svg/common/icon_search.svg": 79334,
	"./images/svg/exercise/bg_compoundExercise.svg": 78268,
	"./images/svg/exercise/community/EMISOntap_Ngang_negative.svg": 20357,
	"./images/svg/exercise/compose/icon_description_tour_guide.svg": 20032,
	"./images/svg/game/ic_back.svg": 86040,
	"./images/svg/game/ic_back_green.svg": 52711,
	"./images/svg/game/ic_confirm_game_mascot.svg": 31351,
	"./images/svg/game/ic_exit_game_mascot.svg": 6887,
	"./images/svg/game/ic_game_amount.png": 60441,
	"./images/svg/game/ic_game_clock.svg": 74751,
	"./images/svg/game/ic_game_time.png": 43290,
	"./images/svg/game/ic_more.png": 10353,
	"./images/svg/game/ic_next.svg": 61725,
	"./images/svg/game/ic_next_green.svg": 61217,
	"./images/svg/game/ic_play_game_mascot.svg": 19253,
	"./images/svg/game/ic_power_stone.svg": 9563,
	"./images/svg/game/ic_power_stone_cat.svg": 53162,
	"./images/svg/game/ic_power_stone_mascot.svg": 15131,
	"./images/svg/game/ic_progress_animation.svg": 40372,
	"./images/svg/game/ranking/continue_active.svg": 65870,
	"./images/svg/ic_PDF_24.svg": 82554,
	"./images/svg/ic_Video_24.svg": 32139,
	"./images/svg/ic_Word_24.svg": 878,
	"./images/svg/ic_add.svg": 20774,
	"./images/svg/ic_exercisePro.svg": 77868,
	"./images/svg/ic_hsinh.svg": 64269,
	"./images/svg/ic_miniArrowRight.svg": 53467,
	"./images/svg/ic_miniArrowRightWhite.svg": 19518,
	"./images/svg/ic_removeQuestion.svg": 25429,
	"./images/svg/ic_storageLibrary.svg": 18461,
	"./images/svg/ic_x_40.svg": 84774,
	"./images/svg/img_exercise.svg": 10700,
	"./images/svg/img_google_error.svg": 17368,
	"./images/svg/profile/achievements/achievements_rank_five.svg": 59003,
	"./images/svg/profile/achievements/achievements_rank_four.svg": 56971,
	"./images/svg/profile/achievements/achievements_rank_one.svg": 61665,
	"./images/svg/profile/achievements/achievements_rank_three.svg": 61957,
	"./images/svg/profile/achievements/achievements_rank_two.svg": 76039,
	"./images/svg/profile/img_profile_beta.svg": 38936,
	"./images/svg/training/bg_blue.svg": 6865,
	"./images/svg/training/bg_orange.svg": 66647,
	"./images/svg/training/bg_purple.svg": 90551,
	"./images/svg/training/ic_QA.svg": 68216,
	"./images/svg/training/ic_check.svg": 60638,
	"./images/svg/training/ic_checkCircle.svg": 60022,
	"./images/svg/training/ic_facebook.svg": 7586,
	"./images/svg/training/ic_training.svg": 82904,
	"./scss/common/_element-variables.scss": 64603
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53373;